/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterView } from './FilterView';
import {
    FilterViewFromJSON,
    FilterViewFromJSONTyped,
    FilterViewToJSON,
    FilterViewToJSONTyped,
} from './FilterView';

/**
 * 
 * @export
 * @interface FindAllFilterViews200Response
 */
export interface FindAllFilterViews200Response {
    /**
     * 
     */
    data?: Array<FilterView>;
}

/**
 * Check if a given object implements the FindAllFilterViews200Response interface.
 */
export function instanceOfFindAllFilterViews200Response(value: object): value is FindAllFilterViews200Response {
    return true;
}

export function FindAllFilterViews200ResponseFromJSON(json: any): FindAllFilterViews200Response {
    return FindAllFilterViews200ResponseFromJSONTyped(json, false);
}

export function FindAllFilterViews200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFilterViews200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FilterViewFromJSON)),
    };
}

export function FindAllFilterViews200ResponseToJSON(json: any): FindAllFilterViews200Response {
    return FindAllFilterViews200ResponseToJSONTyped(json, false);
}

export function FindAllFilterViews200ResponseToJSONTyped(value?: FindAllFilterViews200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FilterViewToJSON)),
    };
}

